import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static values = {
    lines: Number,
    lineHeight: Number
  }

  static targets = ["showMore", "content", "showLess"]

  initialize() {
    const lineHeight = this.lineHeightValue
    const lines = this.linesValue
    this._maxHeight = lineHeight * lines

    if (this.contentTarget.offsetHeight > this._maxHeight) {
      this.showLess()
    }
  }

  showMore() {
    this.contentTarget.style.maxHeight = ""
    this.contentTarget.classList.remove("-truncated")
    hideElement(this.showMoreTarget)
    if (this.hasShowLessTarget) {
      showElement(this.showLessTarget)
    }
  }

  showLess() {
    this.contentTarget.style.maxHeight = this._maxHeight + "px"
    this.contentTarget.classList.add("-truncated")
    showElement(this.showMoreTarget)
    if (this.hasShowLessTarget) {
      hideElement(this.showLessTarget)
    }
  }
}
